<div class="card mt-1">
  <div class="card-body">
    <div class="d-flex align-middle justify-content-between mb-2">
      <div><h4>Validate Referral</h4></div>
      <div>
        <div class="text-end">
          <div><strong>RX WRITTEN DATE:</strong> {{ capture.candidate.writtenDate | date: 'MM/dd/yyyy' }}</div>
          @if (canEditRmvs) {
            <div><button class="btn btn-secondary" (click)="onEditRmvsClick($event)">Edit RVMs</button></div>
          }
        </div>
      </div>
    </div>
    <app-referral-match-form
      [capture]="capture"
      [patientPrescriber]="patientPrescriber"
      [patientPrescriptions]="patientPrescriptions" />
    @if (displayLegacyInfo) {
      <app-legacy-referral-match-form
        [legacyReferralMatchVerification]="patientPrescriber.legacyReferralMatchVerification"
        />
    }
  </div>
</div>
